module.exports = __webpack_public_path__ + "@/assets/img/koku-gri.3c26f55a.jpeg";